import { Component, inject } from '@angular/core';
import { StandPerRegisterService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  StandPerRegisterCreateDto,
  StandPerRegisterDto,
  StandPerRegisterExcelDownloadDto,
  StandPerRegisterUpdateDto,
} from '../proxy/planning/dtos/stand-per-register';
import { STANDPERREGISTER_CONFIG, STANDPERREGISTER_FIELDS } from './stand-per-register.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-stand-per-register',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, StandPerRegisterService, ConfirmationService],
  templateUrl: './stand-per-register.html',
  styleUrl: './stand-per-register.scss',
})
export class StandPerRegister extends BaseCrudComponent<
  StandPerRegisterDto,
  StandPerRegisterCreateDto,
  StandPerRegisterUpdateDto,
  StandPerRegisterExcelDownloadDto
> {
  service = inject(StandPerRegisterService);
  config = STANDPERREGISTER_CONFIG;
  fields = STANDPERREGISTER_FIELDS;

  protected prepareUpdateDto(data: any, selected: StandPerRegisterDto): StandPerRegisterUpdateDto {
    return {
      standRegisterArea: data.standRegisterArea,
      standAreaPercentage: data.standAreaPercentage,
      registerAreaPercentage: data.registerAreaPercentage,
      isMainRegister: data.isMainRegister,
      isLastRegister: data.isLastRegister,
      isStandPerRegisterAvailableInGis: data.isStandPerRegisterAvailableInGis,
      standId: data.standId,
      registerId: data.registerId,
      propertyId: data.propertyId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'StandPerRegister';
  }
}
